<script>
// CommitChart.js
import Chart from 'chart.js'
import { Bar, HorizontalBar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

Chart.defaults.global.animation.duration = 0;
Chart.defaults.global.defaultFontFamily = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"';
Chart.defaults.global.defaultFontSize = 16;
Chart.defaults.global.maintainAspectRatio = false;
Chart.defaults.global.legend.position = 'bottom';

export default {
  extends: HorizontalBar,
  props: ["chartData", "options"],
  mixins: [reactiveProp],
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>
